export const itemsOnPage = 10;

export const providerItems = [
  {
    value: 'all',
    key: 'all',
    renderElement: 'All providers',
    selectedRenderElement: 'All providers',
    active: true,
  },
  {
    value: 'FIABLE',
    key: 'fiable',
    renderElement: 'Fiable',
    selectedRenderElement: 'Fiable',
    active: false,
    type: 'slots',
  },
  {
    value: 'AMATIC',
    key: 'amatic',
    renderElement: 'Amatic',
    selectedRenderElement: 'Amatic',
    active: false,
    type: 'slots',
  },
  {
    value: 'PRAGMATIC',
    key: 'pragmatic',
    renderElement: 'Pragmatic',
    selectedRenderElement: 'Pragmatic',
    active: false,
    type: 'slots',
  },
  {
    value: 'OUTCOMEBET',
    key: 'outcomebets',
    renderElement: 'Outcome',
    selectedRenderElement: 'Outcome',
    active: false,
    type: 'slots',
  },
  {
    value: 'SLOTEGRATOR',
    key: 'slotegrator',
    renderElement: 'Slotegrator',
    selectedRenderElement: 'Slotegrator',
    active: false,
    type: 'slots',
  },
  {
    value: 'HABANERO',
    key: 'habanero',
    renderElement: 'Habanero',
    selectedRenderElement: 'Habanero',
    active: false,
    type: 'slots',
  },
  {
    value: 'EVOPLAY',
    key: 'evoplay',
    renderElement: 'Evoplay',
    selectedRenderElement: 'Evoplay',
    active: false,
    type: 'slots',
  },
  {
    value: 'EVOLUTION',
    key: 'evolutionlive',
    renderElement: 'Evolution',
    selectedRenderElement: 'Evolution',
    active: false,
    type: 'live-casino',
  },
  {
    value: 'TVBET',
    key: 'tvbet',
    renderElement: 'Tvbet',
    selectedRenderElement: 'Tvbet',
    active: false,
    type: 'live-casino',
  },
  {
    value: 'SOFTGAMING',
    key: 'softgaming',
    renderElement: 'Softgaming',
    selectedRenderElement: 'Softgaming',
    active: false,
    type: 'slots',
  },
  {
    value: 'PGSOFT',
    key: 'pgsoft',
    renderElement: 'PGSoft',
    selectedRenderElement: 'PGSoft',
    active: false,
    type: 'slots',
  },
  {
    value: 'GOLDENRACE',
    key: 'goldenrace',
    renderElement: 'Golden race',
    selectedRenderElement: 'Golden race',
    active: false,
    type: 'virtual',
  },
  // {
  //   value: 'BSWGAMES',
  //   key: 'bsw',
  //   renderElement: 'Bsw',
  //   selectedRenderElement: 'Bsw',
  //   active: false,
  //   type: 'slots',
  // },
  {
    value: 'GR8',
    key: 'gr8',
    renderElement: 'Gr8',
    selectedRenderElement: 'Gr8',
    active: false,
    type: 'slots',
  },
  {
    value: 'DIGITAIN',
    key: 'digitain',
    renderElement: 'Digitain',
    selectedRenderElement: 'Digitain',
    active: false,
    type: 'slots',
  },
  // {
  //   value: 'XPG',
  //   key: ProviderName.xpg,
  //   renderElement: 'Xpg',
  //   selectedRenderElement: 'Xpg',
  //   active: false,
  //   type: 'live-casino',
  // },
];

// export const gameTypeItems = [
//   { value: 'all', key: 'all', renderElement: 'All', selectedRenderElement: 'All', active: true },
//   {
//     value: 'slots',
//     key: 'slots',
//     renderElement: 'Slots',
//     selectedRenderElement: 'Slots',
//     active: false,
//   },
//   {
//     value: 'live-casino',
//     key: 'live-casino',
//     renderElement: 'Live casino',
//     selectedRenderElement: 'Live casino',
//     active: false,
//   },
//   {
//     value: 'virtual',
//     key: 'virtual',
//     renderElement: 'Virtual',
//     selectedRenderElement: 'Virtual',
//     active: false,
//   },
// ];
export const statusItems = [
  { value: 'all', key: 'all', renderElement: 'All', selectedRenderElement: 'All', active: true },
  { value: 'bet', key: 'bet', renderElement: 'bet', selectedRenderElement: 'bet', active: false },
  { value: 'win', key: 'win', renderElement: 'win', selectedRenderElement: 'win', active: false },
];
